import { defineStore } from 'pinia';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { DutyTemplateApiResponse } from '@/rennovation/planning-view/types/api/duty-template-response';
import { useI18n } from 'vue-i18n';
import { useAlertStore } from '@/rennovation/planning-view/store/useAlertStore';

export const useDutyTemplateBridgeStore = defineStore('dutyTemplateBridge', () => {
	const { t } = useI18n();
	const vuex = useStore();
	const alertStore = useAlertStore();

	const dutyTemplates = computed<DutyTemplateApiResponse>(() => vuex.state.dutyTemplates.dutyTemplates || []);

	const fetchDutyTemplates = async (deleted: boolean = false, excludeProvider: boolean = false): Promise<void> => {
		try {
			await vuex.dispatch('dutyTemplates/load', { deleted, excludeProvider });
		} catch (error) {
			console.error('Failed to load duty templates via bridge store:', error);
			const errorMessage = error?.response?.data?.message || t('data_load_failed');
			alertStore.showAlert(errorMessage, 'error');
			throw error;
		}
	};

	return {
		dutyTemplates,
		fetchDutyTemplates,
	};
});
